export class BHErecibidaFilter {
   emisorID: string;
   nombreEmisor: string;
   rutEmisorBh: string;
   folio: number;
   fechaDesde: Date;
   fechaHasta: Date;
   fechaEmision: Date;
   regionReceptor: string;
   comunaReceptor: string;
}
